import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useMemo } from 'react';
import { findThankYouPageMapExtension } from '../integrationStatusUtils';
import { OrderStatusPageMapIntegration } from './order-status-page-map-integration/OrderStatusPageMapIntegration';
import { ThankYouPageMapIntegration } from './thank-you-page-map-integration/ThankYouPageMapIntegration';

export const AfterCheckupPointIntegrations = ({
    extensions,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: AfterCheckupPointIntegrationsProps) => {
    const thankYouPageMapIntegration = useMemo(() => findThankYouPageMapExtension(extensions), [extensions]);

    return (
        <>
            <ThankYouPageMapIntegration
                thankYouPageMapIntegration={thankYouPageMapIntegration}
                isLoading={isLoading}
                condensed={condensed}
                handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
            />
            <s-divider />
            <OrderStatusPageMapIntegration
                orderStatusPageMapIntegration={thankYouPageMapIntegration}
                isLoading={isLoading}
                condensed={condensed}
                handleClickAddStoreAppBlock={handleClickAddStoreAppBlock}
            />
        </>
    );
};

interface AfterCheckupPointIntegrationsProps {
    extensions: ExtensionInfo[];
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
